/**
 * Copyright (c) Microsoft. All rights reserved.
 */

type PortalFeatureToggles = Window['luisAppSettings']['featureToggles'] & {
	LanguageStudioMaintenanceDateWindow?: string;
};

export const FeatureToggles = window.luisAppSettings.featureToggles as PortalFeatureToggles;
